<div [matTooltip]="compact() ? student().fullname : null" [style.background-color]="color()" class="indicatorDot">
	{{ student().firstname | slice: 0 : 1 }}{{ student().lastname | slice: 0 : 1 }}
</div>
<span
	#studentName
	[@zoomInOnEnter]
	[@zoomOutOnLeave]
	[matTooltip]="showTooltip() ? student().fullname : null"
	class="studentName secondary"
>
	{{ student().fullname }}
</span>
@if (isLocked()) {
	<span class="badge colored" [@zoomInOnEnter] [@zoomOutOnLeave]>
		<mat-icon fontIcon="fa-lock-keyhole" fontSet="far" inline />
	</span>
} @else if (duplicateCount()) {
	<span
		class="badge {{ SimStatusPalette.warn }}"
		[matTooltip]="T.EXAM_SCHEDULE_STUDENT_ITEM_WARN_TOOLTIP | translate: {duplicateCount: duplicateCount()}"
		matTooltipClass="warnTooltip"
	>
		<mat-icon fontIcon="fa-rotate-exclamation" [style.color]="color()" fontSet="fas" inline />
		<span [style.color]="color()">
			{{ duplicateCount() }}
		</span>
	</span>
}
